export class MinBilConsentModel {
    CustomerId: string;
    EmailConsent: boolean;
    SMSConsent: boolean;
    CampaignConsent: boolean;
    CampaignNotificationConsent: boolean;
    IsMinBilUser: boolean;
    Source: string;
}